/**
 * A place to put base/shared selectors that are causing circular imports.
 *
 * These selectors should only return a slice of the BetSlip store and not use createSelector()
 */

export const selectUserSelections = state => state.betslip.userSelections;
